<template src="./background-header.html"></template>
<style lang="less" scoped src="./background-header.less"></style>

<script>
    export default {
        props: {
            color: String,
            altura: {type: String, default: '150px'}
        },
        computed: {
            coverStyle() {
                return {
                    'background-color': this.color,
                     height: this.altura
                }
            }
        }
    }
</script>